export { RegistrationsPage } from './RegistrationsPage'
